export const pointdatapagetext = {
    method : "Valeurs à afficher",
    display : "Affichage",
    date : "Date",
    value : "Valeur",
    nodata : "Aucune valeur à afficher",
    daterange : "Voir la donnée sur"
}

